import { render, staticRenderFns } from "./InterestsPanel.vue?vue&type=template&id=b486abb8&"
import script from "./InterestsPanel.vue?vue&type=script&lang=ts&"
export * from "./InterestsPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports